import { getContext, createAction } from 'kea'
import PropTypes from 'prop-types'
import NProgress from 'nprogress'
import cookie from 'js-cookie'
import { put, select } from 'redux-saga/effects'

import railsContext from 'lib/selectors/rails-context'

const initScene = {
  name: 'initScene',

  events: {
    beforeBuild (logic, [input, _]) {
      if (input.initScene && input.initScene.scene) {
        const { scene, reload, transform = a => a } = input.initScene
        const {
          options: { sceneDefaults, disableReloadScene }
        } = getContext()

        logic.extend({
          actions: () => ({
            // without path so all listening logic resets when called
            initScene: createAction(`init scene ${scene}`, a => a)
          })
        })

        if (sceneDefaults && sceneDefaults[scene]) {
          logic.extend({
            defaults: transform(sceneDefaults[scene])
          })
        }

        if (reload) {
          logic.extend({
            actions: () => ({
              // with path so only 1 takeLatest starts
              reloadScene: createAction(`reload scene ${scene} (${logic.path.join('.')})`),
              // without path so all listening logic sets isLoadingScene to true
              reloadingScene: createAction(`reloading scene ${scene}`)
            }),
            reducers: ({ actions }) => ({
              isLoadingScene: [
                !sceneDefaults,
                PropTypes.bool,
                {
                  [actions.initScene]: () => false,
                  [actions.reloadScene]: () => true,
                  [actions.reloadingScene]: () => true
                }
              ]
            }),
            takeLatest: ({ actions }) =>
              disableReloadScene
                ? {}
                : {
                  [actions.reloadScene]: function * (action) {
                    yield put(actions.reloadingScene())
                    NProgress.start()
                    try {
                      const response = yield reload()
                      yield put(actions.initScene(response))
                    } finally {
                      NProgress.done()
                    }
                  }
                },
            start: function * () {
              if (typeof window === 'undefined' || disableReloadScene) {
                return
              }
              const fromCookie = parseInt(cookie.get('load_counter'))
              const fromRails = (yield select(railsContext)).loadCounter

              if (!sceneDefaults || fromCookie !== fromRails) {
                yield put(this.actions.reloadScene())
              }
            }
          })
        }
      }
    }
  },

  buildOrder: {
    initSceneReducer: { after: 'reducer' }
  },

  buildSteps: {
    initSceneReducer (logic, input) {
      if (input.initScene && input.initScene.scene) {
        const oldReducer = logic.reducer

        logic.reducer = function (state, action) {
          if (action.type === logic.actions.initScene.toString()) {
            const transformedKeys = (input.initScene.transform || (a => a))(action.payload)
            return { ...oldReducer(state, action), ...transformedKeys }
          }

          return oldReducer(state, action)
        }
      }
    }
  }
}

export default initScene
